import { KafkaLinkedService } from 'app/model/linkedservice/kafka.linkedservice';
import { LinkedServiceAdapter } from './linkedservice.adapter';
import { AdapterRegistry, IModel, Metamodel, kafkaAuthTypes } from 'shell-models-lib';
import { Model } from '../../backendmodel';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { parameterizablePasswordOrAKVtoSecretBase, parameterizableSecretBaseToModel } from './azure-key-vault.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(KafkaLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                bootstrapServers: '*',
                authenticationType: '*',
                saslMechanism: '*',
                userName: '*',
                password: 'secret',
                distroType: '*'
            },
            parameters: '*'
        }
    }
})
export class KafkaLinkedServiceAdapter extends LinkedServiceAdapter<KafkaLinkedService> {
    protected supportFirstClassParameterExperience = true;

    protected modelConstructor(): new () => KafkaLinkedService {
        return KafkaLinkedService;
    }

    protected model(): IModel {
        return KafkaLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: KafkaLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.KafkaLinkedService;
        properties.type = Metamodel.modelFor(KafkaLinkedService).name;
        if (linkedService.authenticationType === kafkaAuthTypes.SASL) {
            properties.typeProperties = {
                bootstrapServers: this.valueToResource(linkedService, KafkaLinkedService.BOOTSTRAPSERVERS),
                authenticationType: linkedService.authenticationType,
                saslMechanism: this.valueToResource(linkedService, KafkaLinkedService.SASLMECHANISM),
                username: this.valueToResource(linkedService, KafkaLinkedService.USER_NAME),
                password: parameterizablePasswordOrAKVtoSecretBase(linkedService, KafkaLinkedService.PASSWORD, this.context),
                distroType: 'kafka'
            };
        }
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: KafkaLinkedService): Promise<KafkaLinkedService> {
        const properties = linkedServiceResource.properties as Model.KafkaLinkedService;
        const typeProperties = properties.typeProperties;
        ValueAdapter.toModel(linkedService, KafkaLinkedService.BOOTSTRAPSERVERS, typeProperties.bootstrapServers);
        linkedService.authenticationType = typeProperties.authenticationType as kafkaAuthTypes;
        ValueAdapter.toModel(linkedService, KafkaLinkedService.SASLMECHANISM, typeProperties.saslMechanism);

        if (linkedService.authenticationType === kafkaAuthTypes.SASL) {
            ValueAdapter.toModel(linkedService, KafkaLinkedService.USER_NAME, typeProperties.username);
            parameterizableSecretBaseToModel(linkedService, KafkaLinkedService.PASSWORD, typeProperties.password, this.context);
        }
        return linkedService;
    }
}
